import DOMPurify from 'dompurify'
import { ATTRIBUTES, DROPPED, ELEMENTS, USER_CONTENT_PREFIX } from '../plans/sanitize'
import { parseMarkdown, slugify } from '../markdown/render'
import type { Context } from './links'
import { resolveRepoUrl } from './links'
export interface Heading { id: string; text: string; level: number }
export function markdownOutline(body: string): Heading[] {
  const tokens = parseMarkdown(body)
  return tokens.flatMap((token, i) => token.type === 'heading_open' ? [{ id: USER_CONTENT_PREFIX + token.attrGet('id'), text: tokens[i + 1]?.children?.map(t => t.content).join('') ?? tokens[i + 1]?.content ?? '', level: Number(token.tag.slice(1)) }] : []).slice(0, 1000)
}
/** Inert fragment first, React's existing plan allowlist second. No HTML is reparsed. */
export function htmlContent(body: string, ctx: Context): { nodes: Node[]; headings: Heading[] } {
  const fragment = DOMPurify(window).sanitize(body, { RETURN_DOM_FRAGMENT: true, ALLOWED_TAGS: [...ELEMENTS], ALLOWED_ATTR: [...ATTRIBUTES], FORBID_TAGS: [...DROPPED], FORBID_CONTENTS: [...DROPPED], SANITIZE_NAMED_PROPS: true })
  fragment.querySelectorAll('a[href]').forEach(a => {
    const target = resolveRepoUrl(a.getAttribute('href') ?? '', 'link', ctx)
    a.setAttribute('href', target.startsWith('#') ? `#${USER_CONTENT_PREFIX}${target.slice(1)}` : target)
  })
  fragment.querySelectorAll('img').forEach(image => image.remove())
  const used = new Set<string>()
  const headings = [...fragment.querySelectorAll('h1,h2,h3,h4,h5,h6')].slice(0, 1000).map(h => {
    const text = h.textContent ?? ''
    const base = h.id || `${USER_CONTENT_PREFIX}${slugify(text) || 'section'}`
    let id = base
    for (let n = 1; used.has(id); n++) id = `${base}-${n}`
    h.id = id
    used.add(id)
    return { id, text, level: Number(h.tagName.slice(1)) }
  })
  return { nodes: [...fragment.childNodes], headings }
}
